import { mixpanelTrack } from "./mixpanel.helper";

export type HelpsiteMixpanelPayload = {
	helpsite_section: string;
	page_path?: string;
	label?: string;
	link_href?: string;
	cta_type?: string;
};

function toPayload(p: HelpsiteMixpanelPayload): Record<string, string> {
	const out: Record<string, string> = { helpsite_section: p.helpsite_section };
	if (p.page_path != null && p.page_path !== "") {
		out.page_path = p.page_path;
	}
	if (p.label != null && p.label !== "") {
		out.label = p.label;
	}
	if (p.link_href != null && p.link_href !== "") {
		out.link_href = p.link_href;
	}
	if (p.cta_type != null && p.cta_type !== "") {
		out.cta_type = p.cta_type;
	}
	return out;
}

export function helpsiteTrackLink(payload: HelpsiteMixpanelPayload) {
	void mixpanelTrack("helpsite_link_clicked", toPayload(payload));
}

export function helpsiteTrackCta(payload: HelpsiteMixpanelPayload) {
	void mixpanelTrack("helpsite_cta_clicked", toPayload(payload));
}

export function helpsiteTrackButton(payload: HelpsiteMixpanelPayload) {
	void mixpanelTrack("helpsite_button_clicked", toPayload(payload));
}
